export enum FooterLayoutType {
    Undefined,
    Single,
    Double5050,
    Double2575,
    Double7525,
    Triple333333,
    Triple255025,
    Triple252550,
    Triple502525,
    Quadruple
}
